import { h } from 'preact';

const LinkedIn = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-label="LinkedIn" {...props}>
			<path d="M17.25 3H6.75A3.75 3.75 0 0 0 3 6.75v10.5A3.75 3.75 0 0 0 6.75 21h10.5A3.75 3.75 0 0 0 21 17.25V6.75A3.75 3.75 0 0 0 17.25 3M9 17.25H6.75V9H9zM7.875 8.049c-.724 0-1.312-.593-1.312-1.323s.587-1.323 1.312-1.323 1.313.592 1.313 1.323S8.6 8.049 7.875 8.049M18 17.25h-2.25v-4.203c0-2.526-3-2.335-3 0v4.203H10.5V9h2.25v1.324C13.797 8.384 18 8.24 18 12.18z" />
		</svg>
	);
};

export default LinkedIn;
